// extracted by mini-css-extract-plugin
export var AuthorAvatarContainer = "bw_fq";
export var AuthorBioContainer = "bw_fn";
export var AuthorContainer = "bw_fm";
export var AuthorGradientBackground = "bw_fp";
export var AuthorInfoContainer = "bw_fr";
export var AuthorInfoDetails = "bw_fs";
export var AuthorInfoName = "bw_ft";
export var AuthorInfoSection = "bw_fv";
export var MuiPopperRoot = "bw_b6";
export var MuiTooltipPopper = "bw_b7";
export var qlTooltipLimited = "bw_b8";